import { CSSProperties } from 'react'
import { screenGap } from './styles.css'

// The gap between the edge of the screen and the drawer is 8px in this case.
export const getDrawerEdgeStyle = () =>
  ({
    '--initial-transform': `calc(100% + ${screenGap}px)`
  }) as CSSProperties
